import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { TemplateRef, ViewChild } from '@angular/core';
import {
  Beneficiario,
  Contrato,
  ContratoWs,
} from '../../models/poblacion/mi-poblacion';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SolicitudService } from '../../services/solicitud/solicitud.service';
import { SolicitudRequestDTO } from '../../models/solicitud/solicitud-request.dto';
import { NgxSpinnerService } from 'ngx-spinner';
import { CorreoService } from '../../services/correo/correo.service';
import { CorreoRequest } from '../../models/correo/correo-request.model';
import { AuthService } from '../../services/security/auth.service';

@Component({
  selector: 'app-solicitud-modal',
  templateUrl: './formulario-solicitud.component.html',
  styleUrls: ['./formulario-solicitud.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormularioSolicitudComponent implements OnInit{
  @ViewChild('dialogFormatoInvalido') dialogFormatoInvalido!: TemplateRef<any>;
  @ViewChild('dialogTamanioExcedido') dialogTamanioExcedido!: TemplateRef<any>;
  @ViewChild('dialogArchivoDuplicado')
  dialogArchivoDuplicado!: TemplateRef<any>;
  @ViewChild('dialogCamposRequeridos')
  dialogCamposRequeridos!: TemplateRef<any>;
  @ViewChild('dialogArchivosRequeridos')
  dialogArchivosRequeridos!: TemplateRef<any>;
  @ViewChild('dialogRadicadoExitoso') dialogRadicadoExitoso!: TemplateRef<any>;
  @ViewChild('dialogError') dialogError!: TemplateRef<any>;
  numeroRadicado: string = '';
  solicitudForm: FormGroup;
  // ciudades: { ciudad: string; codigo: string }[] = [];
  ciudades: any[] = [];
  archivos: { [key: string]: File[] } = {
    ordenMedica: [],
    historiaClinica: [],
  };
  tiposPermitidos: string[] = ['application/pdf', 'image/jpeg', 'image/png'];
  maxSizeMB = 20;
  errorArchivo: { [key: string]: string | null } = {
    historiaClinica: null,
    ordenMedica: null,
  };
  formSubmitted = false;
  numCartilla: string = '';
  logInfo: any;
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private dialogRef: MatDialogRef<FormularioSolicitudComponent>,
    private dialog: MatDialog,
    private solicitudService: SolicitudService,
    private correoService: CorreoService,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ciudades = data.ciudadesDisponibles || [];
    this.solicitudForm = this.fb.group({
      quienRadica: [
        'ASESOR',
        [Validators.required, Validators.pattern('^[a-zA-ZÁÉÍÓÚáéíóúñÑ\\s]+$')],
      ],
      tipoDocumento: [
        data.tipoIdentificacion || '',
        [
          Validators.required,
          Validators.maxLength(4),
          Validators.pattern('^[A-Za-z]+$'),
        ],
      ],
      documento: [
        data.identificacion || '',
        [
          Validators.required,
          Validators.maxLength(20),
          Validators.pattern('^[A-Za-z0-9]+$'),
        ],
      ],
      nombres: [
        data.nombres || '',
        [
          Validators.required,
          Validators.maxLength(80),
          Validators.pattern('^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$'),
        ],
      ],
      apellidos: [
        data.apellidos || '',
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.pattern('^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$'),
        ],
      ],
      ciudad: ['', Validators.required],
      celular: [
        data.celular || '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern('^[0-9]+$'),
        ],
      ],
      correo: [
        data.correo || '',
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
          ),
        ],
      ],
      institucion: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          Validators.pattern('^[a-zA-ZÀ-ÿ0-9ñÑ\\s.,&()\'"-]*$'),
        ],
      ],
      observaciones: [
        '',
        [
          Validators.maxLength(4000),
          Validators.pattern('^[a-zA-ZÀ-ÿ0-9ñÑ\\s.,&()\'"#-]*$'),
          // Letras (incluyendo tildes y ñ), números, espacios y signos comunes: . , & ( ) ' "
        ],
      ],
    });

    

    // Luego de crear el formulario, inyecta los datos
    this.solicitudForm.patchValue({
      tipoDocumento: data.tipoIdentificacion,
      documento: data.identificacion,
      nombres: data.nombres,
      apellidos: data.apellidos,
      celular: data.celular,
      correo: data.correo,
    });
  }

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
  }

  guardarSolicitud() {

    const cleanedInput = this.logInfo.document?.replace('.', '') || '';
    const [tipoId, numeroId] = cleanedInput.split(' ');

    if (this.solicitudForm.invalid) {
      this.formSubmitted = true;
      this.solicitudForm.markAllAsTouched();
      this.dialog.open(this.dialogCamposRequeridos);
      this.spinner.hide();
      return;
    }

    if (
      this.archivos['ordenMedica'].length === 0 ||
      this.archivos['historiaClinica'].length === 0
    ) {
      this.dialog.open(this.dialogArchivosRequeridos);
      return;
    }

    Promise.all([
      this.convertirArchivoABase64(this.archivos['ordenMedica'][0]),
      this.convertirArchivoABase64(this.archivos['historiaClinica'][0]),
    ]).then(([ordenBase64, historiaBase64]) => {
      const formData = this.solicitudForm.getRawValue();
      const solicitud: SolicitudRequestDTO = {
        tipoDoc: formData.tipoDocumento,
        numDoc: formData.documento,
        ciudad: `${formData.ciudad}000`,
        nombre: formData.nombres,
        apellido: formData.apellidos,
        telFijo: '0000000',
        telMovil: formData.celular,
        email: formData.correo,
        identificacionPrestador: '1221121',
        institMedico: formData.institucion,
        observaciones: formData.observaciones,
        radica: '1',
        medioRec: '2',
        credencial: this.data.credencial,
        soportes: [
          {
            tipoSoporte: '2',
            nombreArchivo: this.archivos['ordenMedica'][0].name,
            archivoSolicitud: ordenBase64,
          },
          {
            tipoSoporte: '1',
            nombreArchivo: this.archivos['historiaClinica'][0].name,
            archivoSolicitud: historiaBase64,
          },
        ],
      };

      this.spinner.show();
      this.solicitudService.radicarSolicitud(solicitud).subscribe({
        next: (response: any) => {
          this.spinner.hide();

          const parsedData = JSON.parse(response.data);
          const radicado = parsedData?.lista?.[0]?.codSolicitud || '---';

          const numeroRadicado = radicado;

          const correoRequest: CorreoRequest = {
            from: 'no-responder@coomeva.com.co',
            to: formData.correo,
            cc: formData.correo,
            codCorreo: 'P021',
            jsonParametros: '{"${nroSolicitud}":"' + numeroRadicado + '"}',
            attachments: [
            ],
          };

          this.correoService.enviarCorreo(correoRequest).subscribe({
            next: () => {
              console.log('Correo enviado exitosamente');
            },
            error: (error) => {
              console.error('Error al enviar el correo:', error);
            },
          });

          this.dialog.open(this.dialogRadicadoExitoso, {
            data: { numeroRadicado: radicado },
          });
        },
        error: (err) => {
          this.spinner.hide();

          try {
            const parsedData = JSON.parse(err.error.data);
            const radicado = parsedData?.lista?.[0]?.codSolicitud;

            if (parsedData?.codRespuesta?.codigo === '0' && radicado) {
              this.dialog.open(this.dialogRadicadoExitoso, {
                data: { numeroRadicado: radicado },
              });
              return;
            }
          } catch (e) {}

          const mensaje =
            err?.error?.mensaje ||
            'Ha ocurrido un error al enviar la solicitud.';
          this.dialog.open(this.dialogError, {
            data: { mensajeError: mensaje },
          });
        },
      });
    });
  }

  convertirArchivoABase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = (reader.result as string).split(',')[1];
        resolve(base64);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  onFileChange(event: Event, tipo: 'ordenMedica' | 'historiaClinica') {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      for (let i = 0; i < input.files.length; i++) {
        this.validarArchivo(input.files[i], tipo);
      }
    }
  }

  isDragging: { [key: string]: boolean } = {
    ordenMedica: false,
    historiaClinica: false,
  };

  onDragOver(event: DragEvent, tipo: 'ordenMedica' | 'historiaClinica') {
    event.preventDefault();
    this.isDragging[tipo] = true;
  }

  onDragLeave(event: DragEvent, tipo: 'ordenMedica' | 'historiaClinica') {
    event.preventDefault();
    this.isDragging[tipo] = false;
  }

  onDrop(event: DragEvent, tipo: 'ordenMedica' | 'historiaClinica') {
    event.preventDefault();
    this.isDragging[tipo] = false;

    const file = event.dataTransfer?.files[0];
    if (file) {
      const fileInputEvent = {
        target: { files: event.dataTransfer?.files },
      } as unknown as Event;

      this.onFileChange(fileInputEvent, tipo);
    }
  }

  validarArchivo(file: File, tipo: 'ordenMedica' | 'historiaClinica') {
    const sizeMB = file.size / (1024 * 1024);

    const yaExiste = this.archivos[tipo].some((f) => f.name === file.name);
    if (yaExiste) {
      this.dialog.open(this.dialogArchivoDuplicado, { width: '350px' });
      return;
    }

    if (!this.tiposPermitidos.includes(file.type)) {
      this.dialog.open(this.dialogFormatoInvalido, { width: '350px' });
      return;
    }

    if (sizeMB > this.maxSizeMB) {
      this.dialog.open(this.dialogTamanioExcedido, { width: '350px' });
      return;
    }

    this.archivos[tipo].push(file);
    this.errorArchivo[tipo] = null;
  }

  onFileSelected(event: any, tipo: 'ordenMedica' | 'historiaClinica') {
    const files: FileList = event.target.files;

    for (let i = 0; i < files.length; i++) {
      this.validarArchivo(files[i], tipo);
    }
    event.target.value = '';
  }

  eliminarArchivo(tipo: 'ordenMedica' | 'historiaClinica', index: number) {
    this.archivos[tipo].splice(index, 1);
  }

  cerrarDialogo() {
    this.dialog.closeAll();
  }
}
